import React from 'react'
import CustomInput from '@/product/components/atoms/Inputs/CustomInput'
import RadioBox from '@/product/components/atoms/RadioBox'
import { Box, Button, Card, CardContent, FormLabel, Typography } from '@material-ui/core'
import { Formik, Form } from 'formik'
import * as Yup from 'yup'
import AutoCompleteInputField from '@/custom/components/atoms/AutoCompleteInputField'

export const ListingForm = () => {
    const equipmentCategories = ['Trucks', 'Excavators', 'Bulldozers', 'Cranes', 'Loaders']
    const equipmentBrands = ['Caterpillar', 'Komatsu', 'Volvo', 'Hitachi', 'John Deere', 'Other']
    const equipmentModels = [
        'Front End Loader',
        'Backhoe',
        'Excavator',
        'Crawler',
        'Compactor',
        'Other',
    ]

    const initialValues = {
        category: '',
        brand: '',
        otherBrand: '',
        model: '',
        otherModel: '',
        isRegistered: null,
        registrationNumber: '',
    }

    const validationSchema = Yup.object({
        category: Yup.string().required('Category is required'),
        brand: Yup.string().required('Brand is required'),
        otherBrand: Yup.string().when('brand', {
            is: 'Other',
            then: Yup.string().required('Other brand is required'),
        }),
        model: Yup.string().required('Model is required'),
        otherModel: Yup.string().when('model', {
            is: 'Other',
            then: Yup.string().required('Other model is required'),
        }),
        isRegistered: Yup.boolean().nullable().required('Registration status is required'),
        registrationNumber: Yup.string().when('isRegistered', {
            is: true,
            then: Yup.string().required('Registration number is required'),
        }),
    })

    const handleSubmit = (values, { setSubmitting }) => {
        console.log(values)
        setSubmitting(false)
    }

    return (
        <div className="listing-form-container">
            <Card className="listing-form-card">
                <CardContent>
                    <Typography variant="h6" className="form-title text-left">
                        Sell Your Used Equipment
                    </Typography>
                    <Formik
                        initialValues={initialValues}
                        validationSchema={validationSchema}
                        onSubmit={handleSubmit}
                    >
                        {({ values, setFieldValue, errors, touched, isValid }) => (
                            <Form className="form-content">
                                <div className="row">
                                    <div className="col-sm-12">
                                        <AutoCompleteInputField
                                            id="category-autocomplete"
                                            label="Category *"
                                            options={equipmentCategories}
                                            freeSolo={false}
                                            disableClearable={true}
                                            value={values.category}
                                            onChange={(event, newValue) => {
                                                setFieldValue('category', newValue || '')
                                            }}
                                            error={touched.category && errors.category}
                                        />
                                    </div>
                                    <div className="col-sm-6">
                                        <AutoCompleteInputField
                                            id="brand-autocomplete"
                                            label="Brand *"
                                            options={equipmentBrands}
                                            freeSolo={false}
                                            disableClearable={true}
                                            value={values.brand}
                                            onChange={(event, newValue) => {
                                                setFieldValue('brand', newValue || '')
                                                if (newValue !== 'Other')
                                                    setFieldValue('otherBrand', '')
                                            }}
                                            error={touched.brand && errors.brand}
                                        />
                                    </div>
                                    <div className="col-sm-6">
                                        <AutoCompleteInputField
                                            id="model-autocomplete"
                                            label="Model *"
                                            options={equipmentModels}
                                            freeSolo={false}
                                            disableClearable={true}
                                            value={values.model}
                                            onChange={(event, newValue) => {
                                                setFieldValue('model', newValue || '')
                                                if (newValue !== 'Other')
                                                    setFieldValue('otherModel', '')
                                            }}
                                            error={touched.model && errors.model}
                                        />
                                    </div>
                                </div>
                                {values.brand === 'Other' && (
                                    <div className="row">
                                        <div className="col-sm-6">
                                            <div className="text-field-container">
                                                <CustomInput
                                                    name="otherBrand"
                                                    placeholder="Other Brand *"
                                                    label="Other Brand *"
                                                    type="text"
                                                    upperLabel={true}
                                                    error={touched.otherBrand && errors.otherBrand}
                                                />
                                            </div>
                                        </div>
                                        {values.model === 'Other' && (
                                            <div className="col-sm-6">
                                                <div className="text-field-container">
                                                    <CustomInput
                                                        name="otherModel"
                                                        placeholder="Other Model *"
                                                        label="Other Model *"
                                                        type="text"
                                                        upperLabel={true}
                                                        error={
                                                            touched.otherModel && errors.otherModel
                                                        }
                                                    />
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                )}

                                <div className="row radio-box-container">
                                    <div className="col-sm-12">
                                        <FormLabel
                                            component="legend"
                                            className="form-label text-left"
                                        >
                                            Is your equipment registered? *
                                        </FormLabel>
                                        <RadioBox
                                            name="isRegistered"
                                            value={
                                                values.isRegistered === null
                                                    ? ''
                                                    : values.isRegistered
                                                    ? '1'
                                                    : '0'
                                            }
                                            onChange={(e) => {
                                                const value = e.target.value === '1'
                                                setFieldValue('isRegistered', value)
                                                if (!value) setFieldValue('registrationNumber', '')
                                            }}
                                            items={[
                                                { id: '1', description: 'Yes' },
                                                { id: '0', description: 'No' },
                                            ]}
                                            className="radio-box"
                                            error={touched.isRegistered && errors.isRegistered}
                                        />
                                    </div>
                                    {values.isRegistered && (
                                        <div className="col-sm-12">
                                            <div className="text-field-container">
                                                <CustomInput
                                                    name="registrationNumber"
                                                    placeholder="Registration Number *"
                                                    label="Registration Number *"
                                                    type="text"
                                                    upperLabel={true}
                                                    error={
                                                        touched.registrationNumber &&
                                                        errors.registrationNumber
                                                    }
                                                />
                                            </div>
                                        </div>
                                    )}
                                </div>
                                <div className="button-container row">
                                    <div className="col-6">
                                        <Button variant="contained" className="bulk-button">
                                            Bulk Upload
                                        </Button>
                                    </div>
                                    <div className="col-6">
                                        <Button
                                            variant="contained"
                                            className="create-button"
                                            type="submit"
                                            disabled={!isValid}
                                        >
                                            Create Listing
                                        </Button>
                                    </div>
                                </div>
                            </Form>
                        )}
                    </Formik>
                </CardContent>
            </Card>
        </div>
    )
}
